<template>
  <div class="d-flex align-center px-4 py-2">
    <v-icon left style="font-size: 19px">mdi-format-list-bulleted</v-icon>
    <p class="ma-0 subtitle-1 font-weight-medium">Lista de Filiais Mapeadas</p>

    <v-divider vertical class="mx-5" />

    <slot></slot>

    <v-spacer />

    <mapea-familias-distribuicao-dialog
      :itemSelecionado="itemSelecionado"
      @novo-mapeamento="$emit('atualizar-tabela-filiais-mapeadas', $event)"
      @fecha:dialog="$emit('fecha:dialog', $event)"
      @update:dataTable="$emit('update:dataTable', $event)"
    ></mapea-familias-distribuicao-dialog>
  </div>
</template>

<script>
import MapeaFamiliasDistribuicaoDialog from "./MapeamentoDialog";
export default {
  name: "TopoTabelaFiliaisMapeadasPorFamilia",
  components: {MapeaFamiliasDistribuicaoDialog},
  props: {
    itemSelecionado: {
      type: Object,
      required: false
    }
  }
}
</script>

<style scoped>

</style>
